import { Component, EventEmitter, Input, Output } from '@angular/core';

import { IntelligenceFormatService } from './intelligence.format.service';

// Above this many options a dropdown is taller than its viewport and stops being
// scannable, so the filter renders as a typeahead search instead.
const SEARCH_THRESHOLD = 15;

@Component({
  selector   : 'wor-intelligence-filter',
  template: require('./intelligence.filter.component.html')
})
export class FilterComponent {
  @Input() allLabel = '';
  @Input() name = '';
  @Input() options : Array<string> = [];
  @Input() placeholder = '';
  @Input() value = '';

  @Output() changed = new EventEmitter<string>();

  constructor (
    private intelligenceFormatService: IntelligenceFormatService
  ) {}

  // The typeahead reports its clear button as an empty model, so only reset when a
  // filter was actually set. Typing a partial term must not trigger a reload.
  clearIfEmpty ( value : string ) : void {
    if ( !value && this.value ) {
      this.changed.emit('');
    }
  }

  isSearch () : boolean {
    return ( this.options || [] ).length > SEARCH_THRESHOLD;
  }

  search = ( query : string ) : Promise<Array<string>> => {
    return Promise.resolve(this.intelligenceFormatService.matchOptions(this.options, query));
  }

  select ( value : string ) : void {
    if ( value !== this.value ) {
      this.changed.emit(value);
    }
  }
}
